import { Divider, styled } from '@mui/material';

export const DividerWithMarginStyled = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
